import { useHistory } from 'react-router-dom';
import { TTopUpStatus } from '../NewOutstandingView.helpers';
import { useState } from 'react';
import { getCookie } from '@api/HelperAPI';
import { tracking } from '@iwoca/frontend-tracking-library';
import { Tab } from '@headlessui/react';
import classNames from 'classnames';
import styles from '../NewOutstandingView.module.css';
import { Icon } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { moreFundsMessages } from './MoreFunds.messages';

export const MoreFundsTab = ({
    accountId,
    topUpStatus
}: {
    accountId: string;
    topUpStatus: TTopUpStatus;
}) => {
    const history = useHistory();

    const HIDE_DRAWDOWN_NOTIFICATION_BADGE_COOKIE_NAME =
        'hideDrawdownNotification';
    const [showDrawdownNotificationBadge, setShowDrawdownNotificationBadge] =
        useState(() => {
            return (
                getCookie(HIDE_DRAWDOWN_NOTIFICATION_BADGE_COOKIE_NAME) !==
                'true'
            );
        });
    const hideDrawdownNotificationBadge = () => {
        setShowDrawdownNotificationBadge(false);

        const TWO_WEEKS_IN_SECONDS = 60 * 60 * 24 * 14;
        document.cookie = `${HIDE_DRAWDOWN_NOTIFICATION_BADGE_COOKIE_NAME}=true;max-age=${TWO_WEEKS_IN_SECONDS}`;
    };

    const HIDE_TOPUP_ELIGIBLE_NOTIFICATION_BADGE_COOKIE_NAME =
        'hideTopupEligibleNotification';
    const [
        showTopupEligibleNotificationBadge,
        setShowTopupEligibleNotificationBadge
    ] = useState(() => {
        return (
            getCookie(HIDE_TOPUP_ELIGIBLE_NOTIFICATION_BADGE_COOKIE_NAME) !==
                'true' && topUpStatus === 'TOPUP_ELIGIBLE'
        );
    });
    const hideTopupEligibleNotificationBadge = () => {
        setShowTopupEligibleNotificationBadge(false);

        const TWO_WEEKS_IN_SECONDS = 60 * 60 * 24 * 14;
        document.cookie = `${HIDE_TOPUP_ELIGIBLE_NOTIFICATION_BADGE_COOKIE_NAME}=true;max-age=${TWO_WEEKS_IN_SECONDS}`;
    };

    const HIDE_PRE_APPROVED_NOTIFICATION_BADGE_COOKIE_NAME =
        'hidePreApprovedNotification';
    const [
        showPreApprovedNotificationBadge,
        setshowPreApprovedNotificationBadge
    ] = useState(() => {
        return (
            getCookie(HIDE_PRE_APPROVED_NOTIFICATION_BADGE_COOKIE_NAME) !==
            'true'
        );
    });
    const hideMoreFundsNotificationBadge = () => {
        setshowPreApprovedNotificationBadge(false);

        const TWO_WEEKS_IN_SECONDS = 60 * 60 * 24 * 14;
        document.cookie = `${HIDE_PRE_APPROVED_NOTIFICATION_BADGE_COOKIE_NAME}=true;max-age=${TWO_WEEKS_IN_SECONDS}`;
    };

    const handleRequestMoreFunds = () => {
        tracking.ampli.requestMoreFundsClicked({
            account_id: accountId
        });

        if (topUpStatus === 'TOPUP_ELIGIBLE') {
            hideTopupEligibleNotificationBadge();
            history.push('/apply-flexi-loan/?topup=true');
        }
    };

    const handleTabClicked = () => {
        if (topUpStatus === 'TOPUP_APPROVED') {
            hideDrawdownNotificationBadge();
        } else if (topUpStatus === 'PRE_APPROVED') {
            hideMoreFundsNotificationBadge();
        } else {
            handleRequestMoreFunds();
        }
    };

    let showNotificationBadge = null;
    if (topUpStatus === 'TOPUP_APPROVED') {
        showNotificationBadge = showDrawdownNotificationBadge;
    } else if (topUpStatus === 'PRE_APPROVED') {
        showNotificationBadge = showPreApprovedNotificationBadge;
    } else {
        showNotificationBadge = showTopupEligibleNotificationBadge;
    }

    return (
        <Tab
            className={classNames(styles.tab, {
                [styles.tabNotificationBadge]: showNotificationBadge
            })}
            onClick={handleTabClicked}
        >
            <Icon icon="rocket" className={styles.icon} />
            <FormattedMessage {...moreFundsMessages.tabName} />
        </Tab>
    );
};
